__turbopack_context__.v({
  "imgContainer": "ServiceRequestModal-module-scss-module__Qi7sQW__imgContainer",
  "main": "ServiceRequestModal-module-scss-module__Qi7sQW__main",
  "submitBtn": "ServiceRequestModal-module-scss-module__Qi7sQW__submitBtn",
  "successScreen": "ServiceRequestModal-module-scss-module__Qi7sQW__successScreen",
});
